// import React, { useState, useRef, useEffect } from "react";
// import { UseFormRegister, FieldValues, Path } from "react-hook-form";
// import ArrowDown from "@/assets/icons/ArrowDown.svg";
// import BlueCheck from "@/assets/icons/BlueCheck.svg";

// type Option = {
//   value: string;
//   label: string;
// };

// type SelectItemWithHookFormProps<TFieldValues extends FieldValues> = {
//   label: string;
//   name: Path<TFieldValues>;
//   options: Option[];
//   register: UseFormRegister<TFieldValues>;
//   required?: boolean;
//   placeholder?: string;
// };

// function SelectItemWithHookForm<TFieldValues extends FieldValues>({
//   label,
//   name,
//   options,
//   register,
//   required = false,
//   placeholder = "Select an option...",
// }: SelectItemWithHookFormProps<TFieldValues>) {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState<Option | null>(null);
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   const handleClickOutside = (event: MouseEvent) => {
//     if (
//       dropdownRef.current &&
//       !dropdownRef.current.contains(event.target as Node)
//     ) {
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const getDisplayValue = () => {
//     return selectedOption ? selectedOption.label : placeholder;
//   };

//   const handleSelect = (option: Option) => {
//     setSelectedOption(option);
//     setIsOpen(false);
//   };

//   return (
//     <div ref={dropdownRef} className="w-full">
//       <p className="text-sm font-medium text-gray-700 mb-3">{label}</p>
//       <div className="relative">
//         {isOpen && (
//           <div className="absolute bottom-full max-h-48 drop-shadow-lg overflow-y-auto px-[16px] py-[19px] mb-2 w-full border border-[#F2F4F7] rounded-[8px] bg-white z-10">
//             <div className="flex flex-col">
//               {options.map((option) => (
//                 <SelectOptionItem
//                   key={option.value}
//                   item={option}
//                   isSelected={selectedOption?.value === option.value}
//                   onSelect={() => handleSelect(option)}
//                 />
//               ))}
//             </div>
//           </div>
//         )}
//         <div className={`${isOpen ? "bg-[#17457D]/10 rounded-[8px]" : ""} p-1`}>
//           <div
//             className={`bg-white px-[14px] transition-all duration-300 ease-in-out py-[10px] border flex justify-between ${
//               isOpen ? "border-[#4066A7]" : "border-[#D0D5DD]"
//             } rounded-[8px] cursor-pointer`}
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             <div className="flex gap-x-2 items-center">
//               <p
//                 className={`text-sm select-none ${
//                   selectedOption
//                     ? "text-[#101828] font-medium"
//                     : "text-[#9CA3AF]"
//                 }`}
//               >
//                 {getDisplayValue()}
//               </p>
//             </div>
//             <div
//               className={`transition-all duration-300 ease-in-out ${
//                 isOpen ? "rotate-180" : "rotate-0"
//               }`}
//             >
//               <ArrowDown />
//             </div>
//           </div>
//         </div>
//       </div>
//       <select
//         {...register(name, { required })}
//         value={selectedOption?.value || ""}
//         onChange={(e) => {
//           const newValue = e.target.value;
//           const newOption = options.find((opt) => opt.value === newValue);
//           if (newOption) {
//             setSelectedOption(newOption);
//           }
//         }}
//         className="hidden"
//       >
//         <option value="">{placeholder}</option>
//         {options.map((option) => (
//           <option key={option.value} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// }

// type SelectOptionItemProps = {
//   item: Option;
//   isSelected: boolean;
//   onSelect: () => void;
// };

// function SelectOptionItem({
//   item,
//   isSelected,
//   onSelect,
// }: SelectOptionItemProps) {
//   return (
//     <div
//       onClick={onSelect}
//       className="py-[10px] px-4 rounded-[6px] hover:bg-[#F9FAFB] cursor-pointer flex justify-between items-center"
//     >
//       <div className="inline-flex gap-x-2">
//         <span className="text-[15px] font-medium text-[#101828]">
//           {item.label}
//         </span>
//       </div>
//       {isSelected && <BlueCheck />}
//     </div>
//   );
// }

// export default SelectItemWithHookForm;

import React, { useState, useRef, useEffect } from "react";
import {
  UseFormRegister,
  FieldValues,
  Path,
  UseFormSetValue,
  UseFormWatch,
  PathValue,
  FieldErrors,
} from "react-hook-form";
import ArrowDown from "@/assets/icons/ArrowDown.svg";
import BlueCheck from "@/assets/icons/BlueCheck.svg";
import { object } from "zod";

type Option = {
  id: string;
  title: string;
};

type SelectItemWithHookFormProps<TFieldValues extends FieldValues> = {
  label: string;
  name: Path<TFieldValues>;
  options: Option[];
  register: UseFormRegister<TFieldValues>;
  setValue: UseFormSetValue<TFieldValues>;
  watch: UseFormWatch<TFieldValues>;
  required?: boolean;
  placeholder?: string;
  showOtherInput?: boolean;
  errors: FieldErrors<FieldValues>;
};

function SelectItemWithHookForm<TFieldValues extends FieldValues>({
  label,
  showOtherInput,
  name,
  options=[],
  register,
  setValue,
  watch,
  errors,
  required = false,
  placeholder = "Select an option...",
}: SelectItemWithHookFormProps<TFieldValues>) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Watch the form value for this select field
  const selectedValue = watch(name);

  
  const selectedOption = options?.find(
    (option) => option.title.replace(/\s+/g, "") === selectedValue
  );
  const [isShowOtherInputField, setIsShowOtherInputField] = useState(false);
  const [otherInputValue, setOtherInputValue] = useState("");
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option: Option) => {
    setValue(
      name,
      option.title.replace(/\s+/g, "") as PathValue<
        TFieldValues,
        Path<TFieldValues>
      >
    ); // Update form state
    setIsOpen(false);
  };
  const errorMessage = errors[name]?.message;
  const errorText = typeof errorMessage === "string" ? errorMessage : "";
  return (
    <div ref={dropdownRef} className="w-full">
      <p className="text-sm font-medium text-gray-700 mb-3">{label}</p>
      <div className="relative">
        {isOpen && (
          <div className="absolute bottom-full max-h-48 drop-shadow-lg overflow-y-auto px-[16px] py-[19px] mb-2 w-full border border-[#F2F4F7] rounded-[8px] bg-white z-10">
            <div className="flex flex-col">
              {options?.map((option) => (
                <SelectOptionItem
                  key={option.id}
                  item={option}
                  isSelected={selectedOption?.title === option.title}
                  onSelect={() => handleSelect(option)}
                />
              ))}

              {showOtherInput && (
                <>
                  {!isShowOtherInputField ? (
                    <p
                      onClick={() => setIsShowOtherInputField(true)}
                      className="text-[15px] cursor-pointer font-medium py-[10px] text-[#101828]"
                    >
                      Others
                    </p>
                  ) : (
                    <div className="relative mt-2">
                      <input
                        type="text"
                        value={otherInputValue}
                        onChange={(e) => setOtherInputValue(e.target.value)}
                        placeholder="Type custom option..."
                        className="p-2 w-full text-sm text-gray-700 border rounded-[6px] mb-2 outline-none border-[#4066A7]"
                      />
                      {otherInputValue && (
                        <button
                          onClick={() => {
                            const newOption = {
                              id: Date.now().toString(),
                              title: otherInputValue,
                            };
                            handleSelect(newOption); // update value in form
                            console.log(newOption);
                            options.push(newOption); // mutate or you could lift this up via props if needed
                            setOtherInputValue("");
                            setIsShowOtherInputField(false);
                          }}
                          className="absolute right-2 top-2 bg-[#17457D] text-white px-3 py-1 rounded-[6px] text-sm"
                        >
                          Add
                        </button>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
        <div className={`${isOpen ? "bg-[#17457D]/10 rounded-[8px]" : ""} p-1`}>
          <div
            className={`bg-white px-[14px] transition-all duration-300 ease-in-out py-[10px] border flex justify-between ${
              isOpen ? "border-[#4066A7]" : "border-[#D0D5DD]"
            } rounded-[8px] cursor-pointer`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="flex gap-x-2 items-center">
              <p
                className={`text-sm select-none ${
                  selectedOption
                    ? "text-[#101828] font-medium"
                    : "text-[#9CA3AF]"
                }`}
              >
                {selectedOption ? selectedOption.title : placeholder}
              </p>
            </div>
            <div
              className={`transition-all duration-300 ease-in-out ${
                isOpen ? "rotate-180" : "rotate-0"
              }`}
            >
              <ArrowDown />
            </div>
          </div>
        </div>
      </div>
      <select {...register(name, { required })} className="hidden">
        <option value="">{placeholder}</option>
        {options?.map((option) => (
          <option key={option.id} value={option.id}>
            {option.id}
          </option>
        ))}
      </select>
      {errors[name] && <p className="mt-2 text-sm text-red-600">{errorText}</p>}
    </div>
  );
}

type SelectOptionItemProps = {
  item: Option;
  isSelected: boolean;
  onSelect: () => void;
};

function SelectOptionItem({
  item,
  isSelected,
  onSelect,
}: SelectOptionItemProps) {
  return (
    <div
      onClick={onSelect}
      className="py-[10px] px-4 rounded-[6px] hover:bg-[#F9FAFB] cursor-pointer flex justify-between items-center"
    >
      <div className="inline-flex gap-x-2">
        <span className="text-[15px] font-medium text-[#101828]">
          {item.title}
        </span>
      </div>
      {isSelected && <BlueCheck />}
    </div>
  );
}

export default SelectItemWithHookForm;
